/* eslint no-use-before-define: 0 */
import React, { Component } from 'react';
import { Whisper, Popover } from 'rsuite';
import TitleBar from '../../components/title_bar';
import { connect } from 'react-redux';
import _ from 'lodash';
import ShopListRecipeListItem from '../../components/shop_list_recipe_item';
import AddItems from '../../components/add_items';
import {ShopListItemRow, ShopListItemSection} from '../../components/shop_list_item_row';
import { getReduxStore } from '../../globals';
import  { 
          shoppingListAddRecipe, shoppingListRemoveRecipe, shoppingListUpdateNotes, 
          shoppingListUpdateName, shoppingListUpdateItem
        } from '../../actions/shop_list_actions';
import 'rsuite/dist/styles/rsuite-default.css';
import '../../css/common.css';
import '../../css/shopping_list.css';

class ShoppingList extends Component {

  constructor(props) {
    super(props);

    this.state = { 
      nameIsDirty: false, notesIsDirty: false, shopList: this.props.shopList, 
      recipeList: this.props.recipeList
    };

    this.updateNotes = this.updateNotes.bind(this);
    this.updateRemoteNotes = this.updateRemoteNotes.bind(this);

   // window.addEventListener('resize', this.handleResize);
  }

  componentDidMount() {
    document.title = "Shopping List - " + this.state.shopList.Name;

  //  this.handleResize();
  }

  getShoppingListIndex(sList) {
    const slIdx = this.props.shoppingLists.findIndex(sl => {
      return (sl.Shopping_List_Id === this.state.shopList.Shopping_List_Id)}
    )

    return slIdx;
  }

  getShoppingListRecipeIndex(recipeId)
  {
    const recIdx = this.state.shopList.Recipes.findIndex(r => {
      return (r.RecipeId === recipeId)
    })

    return recIdx;
  }

  incRecipeItemClicked(recItem) {
    getReduxStore().dispatch(shoppingListRemoveRecipe(this.props.shopList, recItem.recipe));
    this.setState({isDirty: true, shopList: this.props.shopList });
  }

  notIncRecipeItemClicked(recItem) {
    getReduxStore().dispatch(shoppingListAddRecipe(this.props.shopList, recItem.recipe));
    this.setState({isDirty: true, shopList: this.props.shopList });
  }

  ingredListItemClick() {

  }

  incRecipeAddClicked(recItem) {
    getReduxStore().dispatch(shoppingListAddRecipe(this.props.shopList, recItem.recipe));
    this.setState({isDirty: true, shopList: this.props.shopList });
  }

  incRecipeRemoveClicked(recItem) {
    getReduxStore().dispatch(shoppingListRemoveRecipe(this.props.shopList, recItem.recipe));
    this.setState({isDirty: true, shopList: this.props.shopList });
  }

  incRecipeItems() {
    var evenrow = true;
      return _.map(this.props.shopList.Recipes, recitm => {
      var rec = this.props.recipeList.find(function(recipe) {
        return ((recipe.Type === "RECIPE") && (recipe.Recipe_Id === this))
      } , recitm.RecipeId);
      if (rec !== undefined) {
        evenrow = !evenrow;
        const reitem = { count: recitm.Count, recipe: rec}
        return (
          <ShopListRecipeListItem 
            onRecipeAdd={this.incRecipeAddClicked.bind(this)} 
            onRecipeRemove={this.incRecipeRemoveClicked.bind(this)} 
            key={rec.Key} 
            recItem={reitem} 
            evenrow={evenrow} 
            included={true}
          />
        );
      }
    });
  }

  itemListItemChanged (item) {
    getReduxStore().dispatch(shoppingListUpdateItem(this.props.shopList, item));
  }

  incItems() {
    var evenrow = true;
    var dept = "";
    return _.map(this.props.shopList.Items, (itm, index) => {
      evenrow = !evenrow;
      if (itm.Location !== dept) {
        dept = itm.Location;
        return (
          <div key={'d' + dept + index}>
            <ShopListItemSection key={dept + index} sectionHdr={dept} />
            <ShopListItemRow key={index} evenRow={evenrow} item={itm} shopListItemChanged={this.itemListItemChanged.bind(this)}/>
          </div>
        );
      }
      else {
        return (
          <ShopListItemRow key={index} evenRow={evenrow} item={itm} shopListItemChanged={this.itemListItemChanged.bind(this)}/>
        )
      }
    });
  }

  notIncRecipeItems() {
    var evenrow = true;

    return _.map(this.props.recipeList, rec => {
      if (rec.Type !== "RECIPE") {
        return( <ShopListRecipeListItem onRecipeSelect={this.notIncRecipeItemClicked.bind(this)} key={rec.Key} recItem={reitem} evenrow={evenrow} included={false}/>)
      }
      evenrow = !evenrow;
      var reitem = { count: 1, recipe: rec}

      return( <ShopListRecipeListItem onRecipeSelect={this.notIncRecipeItemClicked.bind(this)} key={rec.Key} recItem={reitem} evenrow={evenrow} included={false}/>)
    });
  }

  listNameChange(event) {
    this.setState({ nameIsDirty: true});
  }

  updateRemoteListName() {
    if (!this.state.nameIsDirty) { return };
    getReduxStore().dispatch(shoppingListUpdateName(this.props.shopList, this.refs.txtShopListName.value));

    this.setState({notesIsDirty: false })
  }

  updateRemoteNotes() {
    if (!this.state.notesIsDirty) { return };
    getReduxStore().dispatch(shoppingListUpdateNotes(this.props.shopList, this.refs.txtNotes.value));

    this.setState({notesIsDirty: false })
  }

  updateNotes() {
    this.setState({notesIsDirty: true})
  }

  render() {
    const popAddRecipes = (
      <Popover title="Add Recipes" style={{ width: 320,  marginTop: 15, marginRight: 80 }}>
        <ul id="ulNotIncRecipes" className="no-bullet-ul sl-rec-list grn-brdr">
          {this.notIncRecipeItems()}
        </ul>
      </Popover>
    );
    const popAddItems = (
      <Popover title="Add Items" style={{ width: 320,  marginTop: 15, marginRight: 60 }}>
        <AddItems currentItemList={this.props.itemList} shopList={this.state.shopList} />
      </Popover>
    );

    const triggerRef = React.createRef();
    return (
      <div id="sl-bk-div" className="light-bk">
         <TitleBar showContact={true} showBack={true} />
         <div id="divSLMainArea">
            <div style={{textAlign: 'center'}}>
            <div id="divListNameLbl" className="label-font main-font no-break">List Name</div>
              <div>
                <input
                  id="txtShopListName" 
                  ref="txtShopListName" 
                  placeholder="Name" 
                  className="data-txt data-text-lrg" 
                  type="text" 
                  defaultValue={this.props.shopList.Name} 
                  onChange={this.listNameChange.bind(this)} 
                  onBlur={this.updateRemoteListName.bind(this)}
                />
              </div>
            </div>
            <div id="divSLContentArea" className="grn-brdr">
              <div className="divRecIngIncHdr">
                <div className="label-font main-font">Recipes Included in List</div>
                <Whisper placement="auto" speaker={popAddRecipes} ref={triggerRef} trigger="click">
                  <div id="divRecipeAddBtn" className="main-font lt-blue-font">Add Recipe</div>
                </Whisper>
              </div>
              <div id="divRecipList">
                <ul id="ulIncRecipes" className="no-bullet-ul sl-rec-list">
                  {this.incRecipeItems()}
                </ul>
              </div>          
              <div className="divRecIngIncHdr">
                <div className="label-font main-font">Items Included in List</div>
                <Whisper placement="auto" speaker={popAddItems} ref={triggerRef} trigger="click">
                  <div id="divRecipeAddBtn" className="main-font lt-blue-font">Add Item(s)</div>
                </Whisper>
              </div>
              <div id="divSLIngreds">
                <ul id="ulIncludedItems" className="no-bullet-ul sl-inc-item-list grn-brdr">
                  {this.incItems()}
                </ul>
              </div>
              <div id="divNotesArea">
                <div className="label-font main-font">Notes</div>
                <textarea
                  id="txtNotes" ref="txtNotes" placeholder="Notes" 
                  className="highlight-font"
                  onBlur={this.updateRemoteNotes}
                  defaultValue={this.props.shopList.Notes} 
                  onChange={this.updateNotes} 
                />
              </div>
            </div>
      </div>
    </div>  
  )}
}


function mapStateToProps(state) {
  return {  shopList: state.current_shop_list.shop_list, 
            recipeList: state.recipes.acct_recipe_list, 
            shoppingLists: state.shop_lists.shop_list_list,
            itemList: state.items.item_list,
            measureList: state.ref_data.measure_List
        };
}

export default connect(mapStateToProps) (ShoppingList);



// WEBPACK FOOTER //
// ./src/pages/shopping_list/shopping_list.js